import React, { useEffect, useState } from "react"
import ClientProjectChip from "../../../components/molecules/ClientProjectChip.molecule"
import MultiSelect from "../../../components/atoms/MultiSelect.atom"

const TaskProjectDropdown = ({
  projects,
  selectedProjects,
  setSelectedProjects,
  loading,
}) => {
  const [label, setLabel] = useState({
    clientCode: undefined,
    projectCode: undefined,
    value: "Proyectos: Todos",
  })
  const id = `task-project-picker-${new Date().getTime()}`

  useEffect(() => {
    if (selectedProjects.length === 0) {
      setLabel({
        clientCode: undefined,
        projectCode: undefined,
        value: "Proyectos: Todos",
      })
    } else if (selectedProjects.length === 1) {
      const singleProject = projects.find(
        (project) => project.projectID === selectedProjects[0]
      )
      setLabel({
        clientCode: singleProject.clientTagName,
        projectCode: singleProject.projectTagName,
        value: undefined,
      })
    } else if (selectedProjects.length < projects.length) {
      setLabel({
        clientCode: undefined,
        projectCode: undefined,
        value: `${selectedProjects.length} proyectos seleccionados`,
      })
    } else if (selectedProjects.length === projects.length) {
      setLabel({
        clientCode: undefined,
        projectCode: undefined,
        value: "Proyectos: Todos",
      })
    }
  }, [selectedProjects])

  const itemTemplate = (option) => {
    return (
      <div className="flex align-items-center gap-2 overflow-hidden white-space-nowrap text-overflow-ellipsis">
        <ClientProjectChip
          clientCode={option.clientTagName}
          projectCode={option.projectTagName}
          className="text-white"
        />
        <span className="overflow-hidden white-space-nowrap text-overflow-ellipsis">
          {option.projectName}
        </span>
      </div>
    )
  }

  const labelTemplate = () => {
    if (label.value !== undefined) {
      return (
        <span>
          <i className="pi pi-briefcase mr-2"></i>
          {label.value}
        </span>
      )
    } else if (label.clientCode && label.projectCode) {
      return (
        <span className="flex gap-2 align-items-center">
          <i className="pi pi-briefcase mr-2"></i>
          <ClientProjectChip
            clientCode={label.clientCode}
            projectCode={label.projectCode}
            className="text-white"
          />
        </span>
      )
    }
  }
  return (
    <MultiSelect
      inputId={id}
      className="team-member-picker"
      value={selectedProjects}
      itemTemplate={itemTemplate}
      options={projects}
      onChange={(e) => setSelectedProjects(e.value)}
      optionLabel="projectName"
      optionValue="projectID"
      scrollHeight="430px"
      panelClassName="max-w-23rem followed-tasks-project-dropdown"
      placeholder={labelTemplate()}
      maxSelectedLabels={0}
      selectedItemsLabel={labelTemplate()}
      loading={loading}
    />
  )
}

export default TaskProjectDropdown
